<div class="container">
	<div class="background">
		<hum-icon class="icon" [icon]="icon"></hum-icon>
	</div>
</div>
